module.exports = __webpack_public_path__ + "img/approve.087fdd09.svg";